import DownloadIcon from '@mui/icons-material/Download';
import {
  CircularProgress,
  ListItemIcon,
  ListItemText,
  ListItemTextProps,
  MenuItem,
  Tooltip,
  TooltipProps,
} from '@mui/material';
import React from 'react';

interface StudyExportMenuItemProps {
  isLoading?: boolean;
  onClick: () => void;
  disabled?: boolean;
  disabledMessage?: string;
  title: ListItemTextProps['primary'];
  secondaryText?: ListItemTextProps['secondary'];
  tooltip?: TooltipProps['title'];
}

const StudyExportMenuItem: React.FC<StudyExportMenuItemProps> = ({
  disabled,
  disabledMessage,
  isLoading = false,
  onClick,
  title,
  secondaryText,
  tooltip,
}) => {
  return (
    <Tooltip title={disabled ? disabledMessage : tooltip ?? ''} placement="top">
      <span>
        <MenuItem disabled={disabled} onClick={onClick}>
          <ListItemIcon>
            <DownloadIcon />
          </ListItemIcon>
          <ListItemText primary={title} secondary={secondaryText} />
          <ListItemIcon
            sx={{
              marginLeft: 1,
            }}
          >
            {isLoading && <CircularProgress size={16} />}
          </ListItemIcon>
        </MenuItem>
      </span>
    </Tooltip>
  );
};

export default StudyExportMenuItem;
